import { render, staticRenderFns } from "./WPBlockBtn.vue?vue&type=template&id=328ba4b7"
import script from "./WPBlockBtn.vue?vue&type=script&lang=ts"
export * from "./WPBlockBtn.vue?vue&type=script&lang=ts"
import style0 from "./WPBlockBtn.vue?vue&type=style&index=0&id=328ba4b7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports